import { useTrackingInfo } from 'clientState/providers/SearchResponseProvider';
import { useItinerary } from '@components/Results/Components/Itinerary/Provider';

export const calculateAirlineCampaignData = (trackingInfo, itinerary) => {
  const { id } = itinerary;
  const airlineSteeringTracking = trackingInfo?.airlineSteeringTracking || [];
  const hasTrackingId = airlineSteeringTracking.some((trackingInfo) =>
    trackingInfo.sortingPosition.some(
      (element) => element.itineraryId?.toString() === id?.toString()
    )
  );
  return hasTrackingId;
};

const useAirlineSteering = () => {
  const itinerary = useItinerary();
  const trackingInfo = useTrackingInfo();
  const hasAirlineCampaignData = () => {
    return calculateAirlineCampaignData(trackingInfo, itinerary);
  };

  return { hasAirlineCampaignData };
};

export default useAirlineSteering;
